import { devToolsHistoryKeys } from '@src/api/dev-tools-history-api'
import { reportErrorToConsole } from '@src/services/error-logger'
import { apiClient } from '@src/services/http-common'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const TERMINATE_ETL_BATCH_ROUTE = 'dev-tools/terminate-etl-batch-orchestrator'
const TERMINATE_LOAN_VALIDATION_ROUTE = 'dev-tools/terminate-loan-validation-orchestrator'
const IMPORT_ALL_IFX_LOANS_ROUTE = 'dev-tools/import-all-ifx-loans'

const terminateEtlBatchOrchestrator = async (): Promise<void> => {
  try {
    await apiClient.post(TERMINATE_ETL_BATCH_ROUTE)
  } catch (error) {
    reportErrorToConsole(error)
    throw error
  }
}

const terminateLoanValidationOrchestrator = async (): Promise<void> => {
  try {
    await apiClient.post(TERMINATE_LOAN_VALIDATION_ROUTE)
  } catch (error) {
    reportErrorToConsole(error)
    throw error
  }
}

const importAllIfxLoans = async (): Promise<void> => {
  try {
    await apiClient.post(IMPORT_ALL_IFX_LOANS_ROUTE)
  } catch (error) {
    reportErrorToConsole(error)
    throw error
  }
}

const useInvalidateCommandHistory = () => {
  const queryClient = useQueryClient()
  return () => {
    void queryClient.invalidateQueries({ queryKey: devToolsHistoryKeys.all })
  }
}

export const useTerminateEtlBatchOrchestrator = () => {
  const invalidateHistory = useInvalidateCommandHistory()
  return useMutation({
    mutationFn: terminateEtlBatchOrchestrator,
    onSettled: invalidateHistory,
  })
}

export const useTerminateLoanValidationOrchestrator = () => {
  const invalidateHistory = useInvalidateCommandHistory()
  return useMutation({
    mutationFn: terminateLoanValidationOrchestrator,
    onSettled: invalidateHistory,
  })
}

export const useImportAllIfxLoans = () => {
  const invalidateHistory = useInvalidateCommandHistory()
  return useMutation({
    mutationFn: importAllIfxLoans,
    onSettled: invalidateHistory,
  })
}
